module.exports = __webpack_public_path__ + "static/media/klatre-t.2b03c23e.mp3";